import _ from 'lodash';

import { StaticSubscriber } from '@zinnia/form-engine-sdk';

import { PlatformFeatures } from '../../../Models/PlatformFeatures';
import { GenerateParticipantMutation } from '../../../ReactQuery/ParticipantProcessor/generateParticipants.mutations';

export const createGenerateParticipantsSubscriber = (
  features: PlatformFeatures,
  setIsGenerateParticipantsSubscriberActive: (value: boolean) => void,
  generateParticipantsMutation: GenerateParticipantMutation,
): StaticSubscriber => {
  return async (questionnaireEngine, nodeIds) => {
    setIsGenerateParticipantsSubscriberActive(true);
    const nodeIdsAffectingParticipantMedicalInterview =
      features.assistedApplication?.nodeIdsAffectingParticipantMedicalInterview;
    const nodeIdsToWatch = features.assistedApplication?.nodeIdsAffectingParticipantGeneration.concat(
      nodeIdsAffectingParticipantMedicalInterview,
    );

    if (!nodeIdsToWatch || nodeIdsToWatch.length < 1) {
      setIsGenerateParticipantsSubscriberActive(false);
      return;
    }

    const shouldGenerateParticipantMedicalInterviews =
      _.intersection(nodeIdsAffectingParticipantMedicalInterview, nodeIds).length > 0;
    if (_.intersection(nodeIdsToWatch, nodeIds).length > 0) {
      generateParticipantsMutation.mutate({ shouldGenerateParticipantMedicalInterviews, questionnaireEngine });
    }

    setIsGenerateParticipantsSubscriberActive(false);
  };
};
